import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import DescriptionGroup from './DescriptionGroup';
import AddonPageHeader from './AddonPageHeader';
import GalleryGroup from './GalleryGroup';
import RelatedGroup from './RelatedGroup';

import addonDataRaw from '../data/addonData.json';
import variationDataRaw from '../data/variationData.json';
import productDataRaw from '../data/productData.json';

import { Addon } from '../data/interfaces/Addon';
import { Variation } from '../data/interfaces/Variation';
import { Product } from '../data/interfaces/Product';

const addonData = addonDataRaw as Addon[];
const variationData = variationDataRaw as Variation[];
const productData = productDataRaw as Product[];

const AddonPage: React.FC = () => {
    const { slug } = useParams<{ slug: string }>();

    const addon =
        addonData.find((a) => a.slug === slug) || null;

    const product =
        productData.find((p) => p.id === addon?.releaseId) || null;

    const variation =
        variationData.find((v) => v.variationId === addon?.variationId) || null;

    useEffect(() => {
        if (product && addon) {
            document.title = `SecretAria - ${product.title} Add-on: ${addon.title}`;
        }
    }, [product, addon]);

    return (
        <div>
            {addon && product && variation && (
                <>
                    <AddonPageHeader
                        product={product}
                        variation={variation}
                        addon={addon}
                    />

                    <DescriptionGroup description={addon.description} />

                    <GalleryGroup
                        zipName={`${product.slug}-v${variation.variationId}-a${addon.addonId}-${product.version}`}
                        galleryPath={`/assets/releases/${addon.releaseId}/variations/v${variation.variationId}/addons/a${addon.addonId}/gallery`}
                    />

                    <RelatedGroup relatedItems={addon.related ?? []} />
                </>
            )}
        </div>
    );
};


//const AddonPage: React.FC = () => {
//    const { slug } = useParams<{ slug: string }>();
//    const addon = transformedAddons.find((a) => a.slug === slug) || null;
//    const product = productData.find((p) => p.id === addon?.releaseId) || null;
//    const variation = transformedVariations.find((v) => v.variationId === addon?.variationId) || null;

//    useEffect(() => {
//        if (product && addon) {
//            document.title = `SecretAria - ${product.title} Add-on: ${addon.title}`;
//        }
//    }, [product, addon]);

//    return (
//        <div>
//            {addon && product && variation && (
//                <>
//                    <AddonPageHeader product={product} variation={variation} addon={addon} />

//                    <DescriptionGroup description={addon.description} />

//                    <GalleryGroup
//                        zipName={`${product.slug}-v${variation.variationId}-a${addon.addonId}-${product.version}`}
//                        galleryPath={`/assets/releases/${addon.releaseId}/variations/v${variation.variationId}/addons/a${addon.addonId}/gallery`}
//                    />

//                    <RelatedGroup relatedItems={addon.related ?? []} />
//                </>
//            )}
//        </div>
//    );
//};

export default AddonPage;
